import { useQueryClient } from '@tanstack/react-query';
import React from 'react';

import type { Invitation } from '../../schemas/invitation.schema';

import { useSocketStore } from '../../store/useSocketStore';
import { queryKeys } from '../../queryKeys';

export function useInvitationSocket() {
  const { socket } = useSocketStore();
  const queryClient = useQueryClient();

  React.useEffect(() => {
    if (!socket) return;

    const handleInvitation = (invitation: Invitation) => {
      queryClient.setQueryData(
        queryKeys.invitations.fetchInvitationByUserId().queryKey,
        invitation,
      );
    };

    socket.on('invitation:new', handleInvitation);

    return () => {
      socket.off('invitation:new', handleInvitation);
    };
  }, [socket, queryClient]);
}
